<span class="colored-pill-wrapper {{textColor}} {{bgColor}} {{borderColor}}">
    {{ text }}
</span>
